import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../shared/contexts/AuthContext';
import { CWYLoader } from '../common/CWYLoader';

/** Restricts children to users with permissionRole === 'admin'. */
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 240 }}>
        <CWYLoader size={60} />
      </div>
    );
  }

  if (!user || user.permissionRole !== 'admin') {
    return <Navigate to="/app/ledger" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
